import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useIntl} from 'react-intl';
import {useKeycloak} from '@react-keycloak/web';

import './index.style.less';
import {message} from 'antd';
import AppCard from '@crema/core/AppCard';
import {AppMenu} from './AppMenu';
import {Editor} from './Editor';
import {List} from './List';

import {findVitals} from 'services/PatientService';
import {EQUAL} from 'shared/constants/QueryModes';
import {VitalType} from 'shared/constants/AppConst';
import {handleError} from 'utils/MessageUtils';

export const BloodPressure = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const {patientId} = props;

  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const [vital, setVital] = useState();
  const [editing, setEditing] = useState();
  const [viewing, setViewing] = useState();

  const loadData = () => {
    if (patientId?.length > 0) {
      findVitals(headers, patientId, {
        pagination: {current: 1, pageSize: 1},
        filters: [
          {
            fields: 'type',
            mode: EQUAL,
            value: VitalType.BLOOD_PRESSURE,
          },
        ],
        sorters: [
          {
            field: 'modifiedDate',
            order: 'descend',
          },
        ],
      })
        .then((res) => {
          if (res.data?.length > 0) {
            setVital(res.data[0]);
          }
        })
        .catch((error) => handleError(message, error));
    }
  };

  useEffect(() => {
    loadData();
  }, [patientId]);

  const getTitle = () => (
    <div className='detail-header'>
      <img
        className='detail-thumb'
        alt=''
        src='/assets/images/dashboard/icon-blood.svg'
      />
      <div className='detail-header-info'>
        <h3 className='text-truncate'>
          {intl.messages['patient.bloodPressure']}
        </h3>
        <p className='mb-0 text-truncate'>
          {vital ? `${vital?.value} mm[Hg]` : ''}
        </p>
      </div>
    </div>
  );

  return (
    <>
      <AppCard
        title={getTitle()}
        extra={<AppMenu setEditing={setEditing} setViewing={setViewing} />}>
        <div className='detail-content'>
          <div>
            <p>
              {intl.messages['common.modifiedDate']}: {vital?.modifiedDate}
            </p>
          </div>
        </div>
      </AppCard>

      <Editor
        patientId={patientId}
        vital={vital}
        setVital={setVital}
        editing={editing}
        setEditing={setEditing}
      />

      <List patientId={patientId} viewing={viewing} setViewing={setViewing} />
    </>
  );
};

BloodPressure.propTypes = {
  patientId: PropTypes.string,
};
